import {
    Box,
    Container,
    Divider, Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Typography,
    useMediaQuery
} from "@mui/material";
import "../../app.css"
import LogoTransparent from "../../assets/LogoTransparent.png"
import MenuIcon from '@mui/icons-material/Menu';
import {useLocation, useNavigate} from "react-router-dom";
import {useState} from "react";


const navButtonSx = {
    fontFamily: "Barlow",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 500,
    color: "#3B3026",
    cursor: "pointer", // Button-like behavior
    textDecoration: "none", // No underline by default
    "&:hover": {
        textDecoration: "underline", // Underline on hover
        textDecorationColor: "#D39B9B", // Custom underline color on hover
    },
};

const clickedButtonSx = {
    ...navButtonSx, fontWeight: "bold"
}


export function NavBar() {
    const navigate = useNavigate();
    const path = useLocation().pathname;
    const minWidth = useMediaQuery("(min-width:1200px)");
    const drawerWidth = 240;

    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawer = (
        <Box
            onClick={handleDrawerToggle}
            sx={{textAlign: "center", backgroundColor: "#fff9f1", height: "100%"}}
        >
            <Box sx={{display: "flex", alignItems: 'center', justifyContent: 'center', width: "100%"}}>
                <img height={"70px"} src={LogoTransparent} alt={"Logo"}/>
                <Typography variant="h6" sx={{my: 2}}>
                    MiniMax
                </Typography>
            </Box>
            <Divider/>
            <List>
                <ListItem>
                    <ListItemButton
                        onClick={() => {
                            navigate("/");
                            setMobileOpen(false);
                        }}
                        sx={{textAlign: "center"}}
                    >
                        <ListItemText primary={"Over Minimax"}/>
                    </ListItemButton>
                </ListItem>
                <ListItem>
                    <ListItemButton
                        onClick={() => {
                            navigate("/about");
                            setMobileOpen(false);
                        }}
                        sx={{textAlign: "center"}}
                    >
                        <ListItemText primary={"Over Mij"}/>
                    </ListItemButton>
                </ListItem>
                <ListItem>
                    <ListItemButton
                        onClick={() => {
                            navigate("/prijslijst");
                            setMobileOpen(false);
                        }}
                        sx={{textAlign: "center"}}
                    >
                        <ListItemText primary={"Prijzen & Info"}/>
                    </ListItemButton>
                </ListItem>
                <ListItem>
                    <ListItemButton
                        onClick={() => {
                            navigate("/contact");
                            setMobileOpen(false);
                        }}
                        sx={{textAlign: "center"}}
                    >
                        <ListItemText primary={"Contact"}/>
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    );

    return (
        <>
            <Box className={"navBar"} sx={!minWidth ? {alignContent: "center"} : {}}>
                {minWidth &&
                    <Container maxWidth={"lg"} sx={{height: "95px", display: "flex"}}>
                        <Box className={"navContent"}>
                            <Box sx={{display: "flex", gap: "24px"}}>
                                <Typography onClick={() => {
                                    navigate("/");
                                }} sx={path === "/" ? clickedButtonSx : navButtonSx}>Over Minimax</Typography>
                                <Typography onClick={() => {
                                    navigate("/about");
                                }} sx={path === "/about" ? clickedButtonSx : navButtonSx}>Over Mij</Typography>
                                <Typography onClick={() => {
                                    navigate("/prijslijst");
                                }} sx={path === "/prijslijst" ? clickedButtonSx : navButtonSx}>Prijzen & Info</Typography>
                            </Box>
                            <Box sx={{display: "flex", gap: "24px"}}>
                                <Typography onClick={() => {
                                    navigate("/contact");
                                }} sx={path === "/contact" ? clickedButtonSx : navButtonSx}
                                            color="#E19118">Contact</Typography>
                            </Box>
                            <img className={"logo"} src={LogoTransparent} alt={"logo"}/>
                        </Box>
                    </Container>}
                {!minWidth &&
                    <Box sx={{display: "flex", justifyContent: "flex-end", width: "90%"}}>
                        <MenuIcon onClick={handleDrawerToggle} sx={{color: "#E39B3B"}}/>
                        <img className={"logo"} src={LogoTransparent} alt={"logo"}/>
                    </Box>}
            </Box>
            <Box component="nav">
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        "& .MuiDrawer-paper": {
                            boxSizing: "border-box",
                            width: drawerWidth,
                        },
                    }}
                >
                    {drawer}
                </Drawer>
            </Box>
        </>
    );
}